// src/features/locations/ServiceTab.jsx
//
// SERVICE-TAB — IT & Security lens tab on LocationDetail.
// The detail panels show an honest empty state until real feeds (Verkada,
// Alta, ITSM) connect in a future slice.
//
// TODO: gate to admin/IT-ops role when real feeds land.
// TODO: pending product confirmation that "Service" is the final tab label.
//
// All colors via T design tokens; no raw hex in this file.

import React from "react";
import { T } from "../../app/tokens.js";
import { S } from "../../app/styles.js";

// ─── Main component ───────────────────────────────────────────────────────────

/**
 * Service tab content. Detail panels show an empty state until real feeds
 * (Verkada, Alta, ITSM) are connected.
 */
export function ServiceTab() {
  return (
    <div data-testid="service-tab" style={{ display: "flex", flexDirection: "column", gap: S.paneGap }}>
      {/* ── Empty state ─────────────────────────────────────────────── */}
      <div
        data-testid="service-tab-empty-state"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "48px 24px",
          color: T.light,
          fontSize: T.fsSm5,
        }}
      >
        Service feeds not yet connected
      </div>

    </div>
  );
}
